import { useContext, createContext } from 'react';

import { NOT_LOGGED_IN_USER_ID } from '../constants';
import type { AppConfiguration } from '../models';

export const configurationContextDefaultValues: AppConfiguration = {
  currentLanguage: '',
  customerId: NOT_LOGGED_IN_USER_ID,
  globalApiUrl: '',
  graphqlUrl: '',
  identityUrl: '',
  staticApiUrl: '',
  tenant: '',
};

export const configurationContext = createContext<AppConfiguration>(
  configurationContextDefaultValues,
);

export const ConfigurationProvider = configurationContext.Provider;

export const useConfiguration = () => useContext(configurationContext);
